// import Rodal from 'rodal';
// import Rodal from "./rodal.js";
// import "./rodal.css";
import React from "react";
import ReactDOM from "react-dom";
import "./index.less";
import "./rodal.css";
import WeaNewScroll from "../wea-new-scroll";
import middleware from "../../middleware";
import Loadable from "../../react-loadable";
import WindowFunc from "../wea-tools/window";

const Rodal = Loadable({
  loader: () => import("./rodal.js"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
class WeaSlideModal extends React.Component {
  componentDidMount() {
    if (this.props.visible) {
      this.enter(this.props);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.visible && nextProps.visible) {
      this.enter(nextProps);
    } else if (this.props.visible && !nextProps.visible) {
      this.leave(nextProps);
    }
  }

  getDialogContainer() {
    let { layout = WindowFunc.getTop().document.body } = this.props;

    if (window.setLayoutWindow) {
      layout = window.setLayoutWindow.document.body;
    }
    if (!this.dialogContainer) {
      this.dialogContainer = document.createElement("div");
      layout.appendChild(this.dialogContainer);
    }
    return this.dialogContainer;
  }

  enter(props) {
    if (this.props.showMask) {
      this.dialogInstance = ReactDOM.unstable_renderSubtreeIntoContainer(
        this,
        this.getContent(props),
        this.getDialogContainer()
      );
    }
  }

  cleanDialogContainer() {
    const layout = WindowFunc.getTop().document.body;

    if (this.dialogContainer) {
      ReactDOM.unmountComponentAtNode(this.dialogContainer);
      if (layout.contains(this.dialogContainer)) {
        layout.removeChild(this.dialogContainer);
      }
      this.dialogContainer = null;
    }
  }

  componentWillUnmount() {
    this.cleanDialogContainer();
  }

  leave(props) {
    if (this.props.showMask) {
      this.dialogInstance = null;
      if (this.dialogContainer) {
        ReactDOM.unstable_renderSubtreeIntoContainer(
          this,
          this.getContent({
            ...this.props,
            ...props,
            visible: false
          }),
          this.dialogContainer
        );
      }
    }
  }

  getContent = props => {
    const {
      direction = "right",
      title = "",
      content,
      top = 0,
      hasScroll = true,
      className = "",
      style,
      showMask,
      visible,
      closeMaskOnClick,
      onClose
    } = props || this.props;
    const animation = direction === "left" ? "slideLeft" : "slideRight";
    const onClick = closeMaskOnClick ? onClose : null;
    const mask =
      showMask && visible ? (
        <div
          className="rodal-mask"
          style={props.customMaskStyles}
          onClick={onClick}
        />
      ) : null;
    return (
      <div className={`wea-slide-modal ${className}`} style={style}>
        {mask}
        <Rodal
          customMaskStyles={{}}
          {...this.props}
          {...props}
          animation={animation}
          enterAnimation={animation}
          leaveAnimation={animation}
          showCloseButton
          closeOnEsc={false}
        >
          {title && (
            <div className="wea-slide-modal-title wea-f14">{title}</div>
          )}
          <div style={{ height: "100%", paddingBottom: top + 52 }}>
            {hasScroll ? (
              <WeaNewScroll height={"100%"}>
                {content && (
                  <div className="wea-slide-modal-content">{content}</div>
                )}
              </WeaNewScroll>
            ) : (
              <div className="wea-slide-modal-content">{content}</div>
            )}
          </div>
        </Rodal>
      </div>
    );
  };
  render() {
    if (!this.props.showMask) return this.getContent();
    return null;
  }
}

const Com = middleware(WeaSlideModal, "WeaSlideModal");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-slide-modal/index.js